import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class SaleInvoiceService extends GenericService {
  constructor() {
    super('/sale_invoices', axiosInstance);
  }

  async updateCustomerLpo(id, customerLpo) {
    const encodedId = this.encodePathSegment(id);
    const response = await this.axios.put(`${this.baseUrl}/${encodedId}/customer-lpo`, { customer_lpo: customerLpo });
    return response.data;
  }
}

export default new SaleInvoiceService(); 